import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from "../../../constants/anchor"

const deleteCarImage = (carId: string, imageId: string) => async(
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    const params = {
        userId: userData.smsAuth.userId,
        carId,
        imageId
    }
    try {

        const { data: { status } } = await apiInstance.post('/deleteImageFromCloudById', params , config)
        if(status === 'ok') {
            dispatch(({
                type: storeDispatchTypes.deleteCarImage,
                value: {
                    id: carId,
                    imageId
                },
            }))
        }

    } catch (e) {
        console.error('set car sold status error', e)
    }
}

export default deleteCarImage
